/**
 * Subtle auto-rotating carousel for the two mobile-only slide tracks on the
 * registry hero (feature grid + bottom strip). Desktop keeps the static
 * grid layouts — this never runs above the 749px breakpoint.
 *
 * Deliberately restrained: no arrows, no bounce, slides advance on a timer
 * and stop the moment a visitor swipes so it never fights their input.
 */
(function () {
  var MOBILE = window.matchMedia('(max-width: 749px)');
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCarousel(track, dotsEl, intervalMs) {
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;
    var dots = dotsEl ? Array.prototype.slice.call(dotsEl.children) : [];

    var index = 0;
    var timer = null;
    var userInteracted = false;
    var resumeTimer = null;
    var scrollLeftAtGestureStart = 0;

    function setActive(i) {
      index = i;
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === i);
      });
    }

    function goTo(i) {
      var slide = slides[i];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      setActive(i);
    }

    function next() {
      goTo((index + 1) % slides.length);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      if (REDUCED_MOTION || userInteracted || !MOBILE.matches || timer) return;
      timer = setInterval(next, intervalMs);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
              setActive(slides.indexOf(entry.target));
            }
          });
        },
        { root: track, threshold: [0.6] }
      );
      slides.forEach(function (slide) {
        observer.observe(slide);
      });
    }

    // A gesture that STARTS on the strip is not necessarily aimed at it. The
    // commonest one by far is a vertical flick to scroll the PAGE that happens
    // to land on a card, and latching `userInteracted` on touchstart/pointerdown
    // killed autoplay for the rest of the page's life every time that happened.
    //
    // So pause while the pointer is down, then decide once it lifts: only a
    // gesture that actually moved the track sideways was a swipe, and only that
    // stops the rotation for good.
    function beginGesture() {
      if (resumeTimer) {
        clearTimeout(resumeTimer);
        resumeTimer = null;
      }
      scrollLeftAtGestureStart = track.scrollLeft;
      stop();
    }

    function endGesture() {
      if (userInteracted || resumeTimer) return;
      // Let it settle before reading: momentum and scroll-snap keep moving the
      // track after the finger is gone, and on touch the browser fires
      // `pointercancel` the moment it takes over scrolling — long before the
      // swipe has landed anywhere.
      resumeTimer = setTimeout(function () {
        resumeTimer = null;
        if (Math.abs(track.scrollLeft - scrollLeftAtGestureStart) > 4) {
          userInteracted = true;
          return;
        }
        start();
      }, 450);
    }

    track.addEventListener('touchstart', beginGesture, { passive: true });
    ['touchend', 'touchcancel'].forEach(function (evt) {
      track.addEventListener(evt, endGesture, { passive: true });
    });

    // Mouse and pen only: touch already has its own pair above, and binding both
    // families to the same pointer would open and close the gesture twice.
    track.addEventListener(
      'pointerdown',
      function (e) {
        if (e.pointerType === 'touch') return;
        beginGesture();
      },
      { passive: true }
    );
    ['pointerup', 'pointercancel'].forEach(function (evt) {
      track.addEventListener(
        evt,
        function (e) {
          if (e.pointerType === 'touch') return;
          endGesture();
        },
        { passive: true }
      );
    });

    track.addEventListener(
      'wheel',
      function (e) {
        // A vertical wheel over the strip scrolls the page; only a horizontal one
        // is aimed at the carousel, and that one is deliberate enough to keep.
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
        userInteracted = true;
        if (resumeTimer) {
          clearTimeout(resumeTimer);
          resumeTimer = null;
        }
        stop();
      },
      { passive: true }
    );

    MOBILE.addEventListener('change', function (e) {
      if (e.matches) start();
      else stop();
    });

    start();
  }

  function init() {
    initCarousel(
      document.querySelector('[data-reg-carousel="features"]'),
      document.querySelector('[data-reg-carousel-dots="features"]'),
      4000
    );
    initCarousel(
      document.querySelector('[data-reg-carousel="strip"]'),
      document.querySelector('[data-reg-carousel-dots="strip"]'),
      5000
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
